<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_expenses'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(status)="data">
                  <span>
                    <b-button
                      @click="openLossModal(data.item)"
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      Loss
                    </b-button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to View Store</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="loss-modal"
      centered
      title="Enter Quantity Lost"
      title-class="font-14"
      hide-footer
    >
      <div class="form-group">
        <label for="lossQuantity">Quantity Lost</label>
        <input
          type="number"
          v-model="lossQuantity"
          class="form-control"
          id="lossQuantity"
        />
        <small v-if="errorMessage" class="text-danger">
          {{ errorMessage }}
        </small>
      </div>

      <div class="form-group d-flex justify-content-end mt-3">
        <b-button
          type="button"
          class="btn w-30"
          variant="secondary"
          @click="$bvModal.hide('loss-modal')"
          >Close</b-button
        >
        <b-button
          type="button"
          class="btn ms-1 w-30"
          variant="primary"
          @click="submitLoss"
          ><i class="fas fa-check-circle"></i> Submit</b-button
        >
      </div>
    </b-modal>
  </Layout>
</template>
<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  storedetailMethods,
  storedetailComputed,
  inventoryItemMethods,
  inventoryItemComputed,
  inventoryUnitMethods,
  inventoryUnitComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Store Losses",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Store Losses",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Store Losses", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "unit", label: "Unit", visible: true },
        { key: "item", label: "Item", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "addedby", label: "Added by", visible: false },
        { key: "status", label: "Status", visible: true },
        { key: "created_at", label: "Added on", visible: false },
      ],
      selectedItem: null,
      lossQuantity: 0,
      errorMessage: "",
    };
  },
  computed: {
    ...storedetailComputed,
    ...inventoryItemComputed,
    ...inventoryUnitComputed,
    List() {
      return this.storedetails.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.storedetails.map((d) => ({ ...d }));
    },
    IsBusy() {
      return this.storedetails.length === 0;
    },
  },
  mounted() {
    this.fetchStoredetails();
    this.fetchInventoryitems();
    this.fetchInventoryunits();
    this.TotalRows = this.storedetails.length;
    this.isBusy = false;
  },
  watch: {
    lossQuantity() {
      this.validateLossQuantity();
    },
  },
  methods: {
    ...storedetailMethods,
    ...inventoryItemMethods,
    ...inventoryUnitMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openLossModal(item) {
      this.selectedItem = item;
      this.lossQuantity = 0;
      this.$bvModal.show("loss-modal");
    },

    validateLossQuantity() {
      if (this.lossQuantity < 0) {
        this.errorMessage = "Quantity lost cannot be less than zero.";
      } else if (this.lossQuantity > this.selectedItem?.quantity) {
        this.errorMessage = "Quantity lost cannot exceed available quantity.";
      } else {
        this.errorMessage = "";
      }
    },
    async submitLoss() {
      if (this.lossQuantity <= 0) {
        this.$bvToast.toast("Quantity lost must be greater than zero.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (
        this.lossQuantity > 0 &&
        this.lossQuantity <= this.selectedItem.quantity
      ) {
        try {
          let formData = new FormData();
          formData.append("id", parseInt(this.selectedItem.id));

          formData.append("lossQuantity", this.lossQuantity);

          let url = "/storeloss";
          let response = await axios.post(url, formData);

          if (response.status === 200) {
            // Update the item quantity in the frontend
            this.selectedItem.quantity = response.data.newQuantity;

            this.$bvModal.hide("loss-modal");
            this.$bvToast.toast("Quantity updated successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });
          }
        } catch (error) {
          this.$bvToast.toast("Failed to update quantity.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else {
        this.$bvToast.toast("Invalid loss quantity.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
  },
};
</script>
